import React from "react";
import { Grid, Stack, Typography, CircularProgress, Box } from "@mui/material";
import { Files, FileX } from "@phosphor-icons/react";
import { formatFileSize } from "utils/formatFileSize";
import { useTheme } from "@emotion/react";

const DocumentPreview = ({
  error,
  presignedUrl,
  handleClick,
  renderedInModal,
  fileSize,
  fileName,
  urlLoading,
}) => {
  const theme = useTheme();
  const palette = theme.palette;
  return (
    <Grid
      item
      onClick={error ? undefined : handleClick}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        padding: "16px",

        borderRadius: "12px",
        backgroundColor: renderedInModal ? "none" : "action.hover",
        cursor: presignedUrl && !error ? "pointer" : "default",
        ...(error
          ? {} // no hover style when there's an error
          : {
              "&:hover": {
                backgroundColor: "action.selected",
              },
            }),
      }}
    >
      <Stack direction="row" alignItems="center" gap={"16px"} sx={{ width: "100%" }}>
        <Box sx={{ flexShrink: 0 }}>
          {error ? (
            <FileX size={24} color={palette.error.main} weight="duotone" />
          ) : (
            <Files size={24} color={palette.primary.main} weight="duotone" />
          )}
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle3"
            color={palette.text.primary}
            noWrap
            sx={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {fileName}
          </Typography>

          {!!fileSize && renderedInModal && (
            <Typography variant="body2" color={palette.text.secondary}>
              {`${formatFileSize(fileSize)} \u2022 Complete`}
            </Typography>
          )}
        </Box>
      </Stack>
      {urlLoading ? (
        <Stack>
          <CircularProgress color="primary" size={24} />
        </Stack>
      ) : null}
    </Grid>
  );
};

export default DocumentPreview;
